var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-autocomplete',_vm._g(_vm._b({attrs:{"items":_vm.items,"placeholder":_vm.l.t('selector.select-a-country', 'Select a country')}},'w-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }